<script>
import { FormModel } from '@/components/global/form';
import { scrollToError } from '../../utilities/helpers';

export default {
    name: 'CcConfirmationForm',

    props: {
        initialData: null,
        documentSignInitiated: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            loading: false,
            model: null,
            timeoutId: null,
            polling: false,
            iframeUrl: null,
        };
    },

    created() {
        this.model = new FormModel(this.initialData);
    },

    mounted() {
        if (!this.documentSignInitiated) {
            return;
        }

        this.statusCheck();
    },

    methods: {
        async submit() {
            if (this.loading) {
                return;
            }
            this.loading = true;

            try {
                if (this.timeoutId) {
                    window.clearTimeout(this.timeoutId);
                    this.timeoutId = null;
                    this.polling = false;
                }

                const response = await this.$http.post('', this.model.data);
                if (response.data.data.confirmed) {
                    window.location = response.data.data.redirect;
                } else {
                    this.iframeUrl = response.data.data.redirect;
                    this.statusCheck();
                }
            } catch (e) {
                this.model.$e.updateFromResponse(e);
                scrollToError();
                this.$sentyReporting.report(e);

                this.loading = false;
            }
        },

        closeModal() {
            this.iframeUrl = null;
        },

        statusCheck() {
            if (this.polling) {
                return;
            }
            this.polling = true;

            // Dokobit confirms the signature via a server postback that arrives
            // later, so keep asking until the request is confirmed.
            const callback = async () => {
                this.timeoutId = null;

                try {
                    const response = await this.$http.get('/legal-entity/confirmation/check');

                    if (response.data.data.confirmed) {
                        this.polling = false;
                        window.location = response.data.data.redirect;

                        return;
                    }
                } catch (e) {
                    this.$sentyReporting.report(e);
                }

                this.timeoutId = window.setTimeout(callback, 3000);
            };

            callback();
        },
    },
};
</script>
